import { render, staticRenderFns } from "./Zarazeni.vue?vue&type=template&id=4851fe9f&"
import script from "./Zarazeni.vue?vue&type=script&lang=ts&"
export * from "./Zarazeni.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports